/**
 * Лента 5 в бандле /app: те же вилки, что /v5/app, без отдельного сервиса.
 *
 * Id помечаем префиксом, чтобы снапшот основной ленты не затёр пятёрку и чтобы
 * карточка ходила в /v5/v1, не в /v2. mir=5 не ставим: сито его уже прячет
 * как внутренний канал feed2.
 */

export const LENTA5_PREFIX = 'v5:';

export function isLenta5Id(id: string): boolean {
  return id.startsWith(LENTA5_PREFIX);
}

export function lenta5BareId(id: string): string {
  return isLenta5Id(id) ? id.slice(LENTA5_PREFIX.length) : id;
}

export function markLenta5<T extends { id?: string; mir?: unknown }>(fork: T): T {
  const id = typeof fork.id === 'string' ? fork.id : '';
  const nextId = id !== '' && !isLenta5Id(id) ? `${LENTA5_PREFIX}${id}` : id;
  // mir=5 сито прячет как внутренний канал. Пятёрка живёт в id, не в mir.
  if (fork.mir === 5) {
    const { mir: _drop, ...rest } = fork;
    return { ...(rest as T), ...(nextId !== '' ? { id: nextId } : {}) };
  }
  if (nextId === id || nextId === '') return fork;
  return { ...fork, id: nextId };
}

/** Карточка и журнал пятёрки — на publication /v5, не на /v2. */
export function lenta5ApiPath(path: string): string | null {
  const match = path.match(/^\/v1\/fork\/([^/?]+)(.*)$/);
  if (match === null) return null;
  let raw = match[1] ?? '';
  try {
    raw = decodeURIComponent(raw);
  } catch {
    /* оставляем как есть */
  }
  if (!isLenta5Id(raw)) return null;
  return `/v5/v1/lanes/live/fork/${encodeURIComponent(lenta5BareId(raw))}${match[2] ?? ''}`;
}
